import React from 'react';
import { HeroContent } from './HeroContent';
import { HeroQuotePanel } from './HeroQuotePanel';
import { TrustBar } from './TrustBar';
import { Services } from './Services';
import { Reviews } from './Reviews';
import { ProjectTypes } from './ProjectTypes';
import { Storefronts } from './Storefronts';
import { InteriorGlass } from './InteriorGlass';
import { ContractGlazing } from './ContractGlazing';
import { ProjectShowcase } from './ProjectShowcase';
import { Industries } from './Industries';
import { Process } from './Process';
import { WhyChoose } from './WhyChoose';
import { Locations } from './Locations';
import { CommercialGlassFAQ } from '../../components/CommercialGlassFAQ/CommercialGlassFAQ';
import { FinalCTA } from './FinalCTA';
import { MobileStickyCTA } from './MobileStickyCTA';
export function CommercialGlass() {
  return <main className="w-full min-h-screen bg-cream-100 pb-20 md:pb-0" data-id="element-461">
      <section className="relative bg-cream-100 border-b border-neutral-200 overflow-hidden" data-id="element-462">
        <div className="absolute inset-0 bg-glass-grid pointer-events-none opacity-60" data-id="element-463"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-white/60 to-cream-100/90 pointer-events-none" data-id="element-464"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-12 lg:pt-10 lg:pb-14" data-id="element-465">
          <div className="grid lg:grid-cols-12 gap-8 lg:gap-10 items-start" data-id="element-466">
            <HeroContent data-id="element-467" />
            <HeroQuotePanel data-id="element-468" />
          </div>
        </div>
      </section>
      <TrustBar data-id="element-469" />
      <Services data-id="element-470" />
      <Reviews data-id="element-471" />
      <ProjectTypes data-id="element-472" />
      <Storefronts data-id="element-473" />
      <InteriorGlass data-id="element-474" />
      <ContractGlazing data-id="element-475" />
      <ProjectShowcase data-id="element-476" />
      <Industries data-id="element-477" />
      <Process data-id="element-478" />
      <WhyChoose data-id="element-479" />
      <Locations data-id="element-480" />
      <CommercialGlassFAQ data-id="element-481" />
      <FinalCTA data-id="element-482" />
      <MobileStickyCTA data-id="element-483" />
    </main>;
}